"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConfigRequestConsolidator = void 0;
/**
 * Ensures we only have one active config request at a time
 * any calls made while another is ongoing will be merged together by using the latest user object provided
 */
var ConfigRequestConsolidator = /** @class */ (function () {
    function ConfigRequestConsolidator(requestConfigFunction, handleConfigReceivedFunction, nextUser) {
        this.requestConfigFunction = requestConfigFunction;
        this.handleConfigReceivedFunction = handleConfigReceivedFunction;
        this.nextUser = nextUser;
        this.resolvers = [];
        this.requestParams = null;
    }
    ConfigRequestConsolidator.prototype.queue = function (user, requestParams) {
        return __awaiter(this, void 0, void 0, function () {
            var resolver;
            var _this = this;
            return __generator(this, function (_a) {
                if (user) {
                    this.nextUser = user;
                }
                if (requestParams) {
                    this.requestParams = requestParams;
                }
                resolver = new Promise(function (resolve, reject) {
                    _this.resolvers.push({
                        resolve: resolve,
                        reject: reject,
                    });
                });
                if (!this.currentPromise) {
                    this.processQueue();
                }
                return [2 /*return*/, resolver];
            });
        });
    };
    ConfigRequestConsolidator.prototype.processQueue = function () {
        return __awaiter(this, void 0, void 0, function () {
            var resolvers;
            var _this = this;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        if (!this.resolvers.length) {
                            return [2 /*return*/];
                        }
                        resolvers = this.resolvers.splice(0);
                        return [4 /*yield*/, this.performRequest(this.nextUser)
                                .then(function (result) {
                                var _a;
                                if (_this.resolvers.length) {
                                    // if more resolvers have been registered since this request was made,
                                    // don't resolve anything and just make another request while keeping all the previous resolvers
                                    (_a = _this.resolvers).push.apply(_a, resolvers);
                                }
                                else {
                                    resolvers.forEach(function (_a) {
                                        var resolve = _a.resolve;
                                        return resolve(result);
                                    });
                                    _this.handleConfigReceivedFunction(result, _this.nextUser);
                                }
                            })
                                .catch(function (err) {
                                resolvers.forEach(function (_a) {
                                    var reject = _a.reject;
                                    return reject(err);
                                });
                            })];
                    case 1:
                        _a.sent();
                        if (this.resolvers.length) {
                            this.processQueue();
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    ConfigRequestConsolidator.prototype.performRequest = function (user) {
        return __awaiter(this, void 0, void 0, function () {
            var bucketedConfig;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.currentPromise = this.requestConfigFunction(user, this.requestParams ? this.requestParams : undefined);
                        this.requestParams = null;
                        return [4 /*yield*/, this.currentPromise];
                    case 1:
                        bucketedConfig = _a.sent();
                        this.currentPromise = null;
                        return [2 /*return*/, bucketedConfig];
                }
            });
        });
    };
    return ConfigRequestConsolidator;
}());
exports.ConfigRequestConsolidator = ConfigRequestConsolidator;
//# sourceMappingURL=ConfigRequestConsolidator.js.map